"use client";

import NextScript from "next/script";
import React, { useEffect } from "react";
import { isDachProduct } from "../../../helpers/isDachProduct";
import { useCountry } from "../../../hooks/useCountry";
import { usePageParams } from "../../../hooks/usePageParams";
import { useConsent, useIsPay } from "../../Consent/hooks";

export const Taboola: React.FC = () => {
    const consent = useConsent();
    const isPay = useIsPay();
    const country = useCountry();
    const { pageType } = usePageParams();

    useEffect(() => {
        let taboolaPageType: Record<string, string> = { article: "auto" };
        if (pageType?.isHomePage) {
            taboolaPageType = { home: "auto" };
        } else if (pageType?.isAnyForecastPage) {
            taboolaPageType = { other: "auto" };
        }

        window._taboola = window._taboola || [];
        window._taboola.push(taboolaPageType);
    }, [pageType?.isAnyForecastPage, pageType?.isHomePage]);

    if (!consent || isPay || !isDachProduct(country)) {
        return null;
    }

    const publisherIds = {
        de: "funke-wettercomde",
        at: "funke-wettercomat",
        ch: "funke-wettercomch",
    };

    return (
        <>
            <div id="taboola-newsroom"></div>
            <NextScript id="taboola-script" strategy="lazyOnload">
                {`
            // A *global* property for queuing *all* Taboola commands on this page:
            window._taboola = window._taboola || [];
    
            // Pixel — fires once on every page load
            new Image().src = 'https://static.tblcontent.com/libtrc/tr5?type=pixel&publisher=${publisherIds[country]}';
    
            !function (e, f, u, i) {
                (function r(s, a, b, c) {
                    if (!document.getElementById(b)) {
                        s.async = 1;
                        s.src = a;
                        s.id = b;
                        if (c) {
                            s.onerror = function () {
                                if (s.parentNode) s.parentNode.removeChild(s);
                                r(
                                    document.createElement('script'),
                                    c,
                                    i + '_fb'
                                );
                            };
                        }
                        f.parentNode.insertBefore(s, f);
                    }
                })(e, u, i, '//static.tblcontent.com/libtrc/${publisherIds[country]}/loader.privacy.js');
            }(
            document.createElement('script'),
            document.getElementsByTagName('script')[0],
                '//cdn.taboola.com/libtrc/${publisherIds[country]}/loader.js',
                'tb_loader_script'
            );

            if (window.performance && typeof window.performance.mark === 'function') {
                window.performance.mark('tbl_ic');
            }
            
            window._taboola.push({  
                mode: 'rbox-tracking',  
                container: 'taboola-newsroom',  
                placement: 'Newsroom',  
            });  
            
            window._taboola.push({flush: true});  
        `}
            </NextScript>
        </>
    );
};
